/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskRuleBreakdownEntry = {
  /**
   * Finding count for this rule within the window.
   */
  findings: number;
  /**
   * Rule identifier (e.g. 'secret.aws-access-key'). Empty when the finding has no rule_id (treat as 'unspecified').
   */
  ruleId: string;
  /**
   * Source bucket the rule belongs to (gitleaks, presidio, etc.) for label/icon resolution on the dashboard.
   */
  source: string;
};

/** @internal */
export const RiskRuleBreakdownEntry$inboundSchema: z.ZodMiniType<
  RiskRuleBreakdownEntry,
  unknown
> = z.pipe(
  z.object({
    findings: z.int(),
    rule_id: z.string(),
    source: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "rule_id": "ruleId",
    });
  }),
);

export function riskRuleBreakdownEntryFromJSON(
  jsonString: string,
): SafeParseResult<RiskRuleBreakdownEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskRuleBreakdownEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskRuleBreakdownEntry' from JSON`,
  );
}
